export const getUserSettings = async (user) => {
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"userSettingsGet?token="+user.token+"&user="+user.id);
    let json = await res.json();
    return json;
}

export const getFiletypes = async (token) =>{
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"dossierTypes?token="+token);
    let json = await res.json();
    return json;
}

export const handleGetAllGroups = async (userdata) =>{
    const token = userdata.token
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"getGroupsAll?token="+token);
    let json = await res.json();
    return json;
}

export const handleGetDocumentsByFilter = async (object) => {
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"getDocumentsByFilter", {
        method:"POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(object)
    });
    let json = await res.json();
    return json;
}

export const handleGetRelation = async (userdata) => {
    const token = userdata.token;
    const relnr = userdata.relnr;

    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"getRelation?token="+token+"&relnr="+relnr);
    let json = await res.json();
    return json;
}

export const handleGetException = async (userdata, fileid, filetypeid) => {
    const token = userdata.token;
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"fileExceptionGet?token="+token+"&fileid="+fileid+"&filetypeid="+filetypeid);
    let json = await res.json();
    return json;
}

export const handleSearchWeighingTickets = async (object) => {
    try {
        const queryString = Object.entries(object)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value && value.toString())}`)
        .join("&");

        let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}getWeighingTickets?${queryString}`)
        let r = await f.json();
        return r;
    }

    catch (e) {
        console.log(e);
        return {errorcode: 999, message:"Failed"}
    }
}

export const handleGetUserRights = async (token, userid) => {
    try {
        let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}getUserRights?token=${token}&userid=${userid}`);
        const d = await f.json();
        return d;
    } catch (e) {
        console.log(e);
        return {errorcode: 999, message:"Failed"}
    }
}